import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RapidStatsService } from '../rapid-stats.service';

export interface StatsData {
  url?: string;
  uniqueVisitors?: number;
  totalVisitors?: number;
  de_rangeStart?: string;
  de_rangeEnd?: string;
  exit?: number;
  pageType?: string;
  bounce?: number;
  unique?: number;
  total?: number;
}


@Injectable()
export class ExitPagesService {

  private _exitPages1$: Subject<StatsData[]>;
  private _exitPages2$: Subject<StatsData[]>;

  private _changeSubscription;
  private isLoading = true;

  private dataStore: {
    selectedName1: '',
    exitPages1: StatsData[],
    selectedName2: '',
    exitPages2: StatsData[]
  };


  constructor(private http: HttpClient, private statsService: RapidStatsService) {
    this.dataStore = {
      selectedName1: '',
      exitPages1: [],
      selectedName2: '',
      exitPages2: []
    };
    this._exitPages1$ = <Subject<StatsData[]>>new Subject();
    this._exitPages2$ = <Subject<StatsData[]>>new Subject();

  }

  changeSubscribe() {
    this._changeSubscription = this.statsService.changed$.subscribe((val) => {
      this.isLoading = true;
      this.loadExitPages();
    });
  }

  changeUnsubscribe() {
    this._changeSubscription.unsubscribe();
  }

  get selectedName1() {
    return this.dataStore.selectedName1;
  }

  get exitPages1$() {
    return this._exitPages1$.asObservable();
  }

  get selectedName2() {
    return this.dataStore.selectedName2;
  }

  get exitPages2$() {
    return this._exitPages2$.asObservable();
  }

  loadExitPages() {
    for (let i = 0; i <= 1; i++) {
      if (typeof this.statsService.selected[i] !== 'undefined') {
        const params: HttpParams = new HttpParams()
        .set('rangeStart', this.statsService.rangeStart.format('YYYY-MM-DD'))
        .set('rangeEnd', this.statsService.rangeEnd.format('YYYY-MM-DD'))
        .set('selectedId', this.statsService.selected[i].id)
        .set('selectedType', this.statsService.selected[i].type);

        const req = this.http.get('/api/stats/getExitPages', { params: params })
          .subscribe((res: any) => {
          if (i === 0) {
            this.dataStore.exitPages1 = res;
            this.dataStore.selectedName1 = this.statsService.selected[i].text;
            this._exitPages1$.next(this.dataStore.exitPages1);
          } else {
            this.dataStore.exitPages2 = res;
            this.dataStore.selectedName2 = this.statsService.selected[i].text;
            this._exitPages2$.next(this.dataStore.exitPages2);
          }
          this.isLoading = false;
        }, error => console.log('Could not load exitPages.'));
      } else {
        if (i === 0) {
          this.dataStore.exitPages1 = [];
          this.dataStore.selectedName1 = '';
          this._exitPages1$.next(this.dataStore.exitPages1);
        } else {
          this.dataStore.exitPages2 = [];
          this.dataStore.selectedName2 = '';
          this._exitPages2$.next(this.dataStore.exitPages2);
        }
      }
    }
  }

}
